import RejectCourseModal from './RejectCourseModal';
export default RejectCourseModal;
